import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { createContext, useEffect, useMemo, useState } from "react";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import useGetReferral from "@hooks/useGetReferral";
import { useLocation, useSearchParams } from "react-router-dom";
import { serverUrl } from "@globalConfig";
import usePreserveData from "@/pages/search/searchHooks/usePreserveData";
import useDetectDeviceByMediaQuery from "@hooks/useDetectDeviceByMediaQuery";
import { DEFAULT_FILTER_PAGE_CONTEXT, DEFAULT_SEARCH_RESULTS_REDUX } from "@/pages/search/searchHooks/searchContextType";
import useIsMobile from "@hooks/useIsMobile";
import filterPageAnalytics from "@/pages/search/searchHooks/analytics";
import { buildParamsObject, extractDealId, getBrowseLink, getSearchPageTitle, isAutosOrYearsScreen, isAutosScreen, isCarCountriesScreen, isDealScreen, isFiltersScreen, isYearsScreen } from "@/pages/search/searchHooks/filtersHelpers";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import useFirstRender from "@hooks/useFirstRender";
import { isInView } from "@/common/HOCs/WithVisibilityTrigger";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { api__doSearch_with_params } from "@/apis/search/search";
import useHelpers from "@hooks/useHelpers";
import { getAutosMakeModelAboutData, getFaqQuestions, getPageDescription } from "@/utils/AutosSEOPageDescription";
import { useLang } from "@/common/Contexts/LanguageContext";
import { getFinancingData, getPricesTableData } from "@/pages/search/searchInitialData";
var CARD_DETAIL = 'cardetail';
var CARD_COMPARE = 'car-compare';
export var searchPaginationContext = /*#__PURE__*/createContext(DEFAULT_FILTER_PAGE_CONTEXT);
export var SearchPaginationContextProvider = function SearchPaginationContextProvider(_ref) {
  var _searchResults$select2, _searchResults$metaDa2, _searchResults$metaDa3, _searchResults$metaDa6, _searchResults$metaDa7;
  var children = _ref.children;
  // refs
  // ref for last elementViewed
  // global helpers
  var location = useLocation();
  var isMobile = useIsMobile();
  var device = useDetectDeviceByMediaQuery();
  var _useState = useState(location.search.includes("page=") ? Number(new URLSearchParams(location.search).get("page")) : 1),
    pageNumber = _useState[0],
    setPage = _useState[1];
  var _useState2 = useState(useFirstRender() && isAutosOrYearsScreen(location)),
    isFirstLanding = _useState2[0],
    setIsFirstLanding = _useState2[1];
  var lang = useLang();
  var fullPageInitialData = useFullPageData();
  // data
  var _usePreserveData = usePreserveData(),
    preserveData = _usePreserveData.preserveData,
    preserveScrollPosition = _usePreserveData.preserveScrollPosition,
    lastScrollPosition = _usePreserveData.lastScrollPosition,
    lastSearchResultsData = _usePreserveData.lastSearchResultsData,
    shouldFetchNewData = _usePreserveData.shouldFetchNewData;

  // Only use cached data if we don't need to fetch new data
  var initialSearchResults = shouldFetchNewData ? fullPageInitialData || DEFAULT_SEARCH_RESULTS_REDUX : lastSearchResultsData || fullPageInitialData || DEFAULT_SEARCH_RESULTS_REDUX;
  var _useState3 = useState(isFiltersScreen(location) && !lastSearchResultsData && !fullPageInitialData),
    isLoading = _useState3[0],
    setIsLoading = _useState3[1];
  var _useState4 = useState(initialSearchResults),
    searchResults = _useState4[0],
    setSearchResults = _useState4[1];
  var isAutosPage = isAutosScreen(location);
  var isCarCountriesPage = isCarCountriesScreen(location);
  var isYearsPage = isYearsScreen(location);
  var isDealPage = isDealScreen(location);
  var _useSession = useSession(),
    search_hashes = _useSession.search_hashes,
    remote_saveSearch = _useSession.remote_saveSearch,
    isLoggedIn = _useSession.isLoggedIn;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isFiltersOnlyPage = !(isYearsPage || isAutosPage || isDealPage);
  var _useState5 = useState(!isMobile),
    showFilters = _useState5[0],
    setShowFilters = _useState5[1];
  var referralPage = useGetReferral();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var searchTerm = searchParams.get("text");
  var sort = searchParams.get("sort");

  // constants
  var dealId = extractDealId(searchParams, location);
  var filters = buildParamsObject(searchParams, location);
  //dispatchers
  var dispatchLoading = function dispatchLoading(val) {
    if (isFirstLanding) return;
    setIsLoading(val);
  };
  //Events
  var runWhenElementViewed = function runWhenElementViewed(el) {
    setTimeout(function () {
      if (!isInView(el)) {
        return;
      }
      setPage(pageNumber + 1);
    }, 10);
  };
  var hasMorePages = function hasMorePages() {
    var _searchResults$metaDa;
    return !!(searchResults !== null && searchResults !== void 0 && (_searchResults$metaDa = searchResults.metaData) !== null && _searchResults$metaDa !== void 0 && _searchResults$metaDa.totalPages && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.metaData.totalPages) > 1 && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.metaData.totalPages) > pageNumber);
  };
  var dispatchSearchAction = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var page,
        _args2 = arguments;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            page = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 1;
            return _context2.a(2, new Promise(function (resolve, reject) {
              dispatchLoading(true);
              api__doSearch_with_params({
                page: page,
                sort: sort,
                size: 16,
                filters: isFiltersScreen(location) ? filters : {},
                link: isFiltersScreen(location) ? "" : getBrowseLink(location),
                includes: ["meta_tags", "seo_data", "quality_section"]
              }).then(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(sResultsReduxData) {
                  var isGtPage1, _getPageDescription, pageDescription1, pageDescription2, seoAboutData, pricesTableData, financingData, faqQuestions, _searchParams;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        isGtPage1 = page > 1;
                        _getPageDescription = getPageDescription(lang, location === null || location === void 0 ? void 0 : location.pathname, sResultsReduxData === null || sResultsReduxData === void 0 ? void 0 : sResultsReduxData.selectedOptions), pageDescription1 = _getPageDescription.pageDescription1, pageDescription2 = _getPageDescription.pageDescription2;
                        seoAboutData = getAutosMakeModelAboutData(location === null || location === void 0 ? void 0 : location.pathname, sResultsReduxData === null || sResultsReduxData === void 0 ? void 0 : sResultsReduxData.selectedOptions);
                        pricesTableData = getPricesTableData(sResultsReduxData === null || sResultsReduxData === void 0 ? void 0 : sResultsReduxData.selectedOptions, lang);
                        _context.n = 1;
                        return getFinancingData(null, sResultsReduxData === null || sResultsReduxData === void 0 ? void 0 : sResultsReduxData.posts);
                      case 1:
                        financingData = _context.v;
                        faqQuestions = getFaqQuestions(seoAboutData, sResultsReduxData === null || sResultsReduxData === void 0 ? void 0 : sResultsReduxData.selectedOptions);
                        if (!isAutosPage) {
                          sResultsReduxData.posts = isGtPage1 ? [].concat(_toConsumableArray(searchResults.posts), _toConsumableArray(sResultsReduxData.posts)) : sResultsReduxData.posts;
                        }
                        setSearchResults(_objectSpread(_objectSpread({}, sResultsReduxData), {}, {
                          pageDescription1: pageDescription1,
                          pageDescription2: pageDescription2,
                          seoAboutData: seoAboutData,
                          pricesTableData: pricesTableData,
                          financingData: financingData,
                          faqQuestions: faqQuestions
                        }));
                        filterPageAnalytics({
                          page: page,
                          filters: filters,
                          isBrowserBehaviour: !isFiltersScreen(location),
                          searchResults: sResultsReduxData,
                          location: location
                        });
                        dispatchLoading(false);
                        if (isGtPage1) {
                          _searchParams = new URLSearchParams(location.search);
                          _searchParams.set("page", sResultsReduxData.metaData.currentPage.toString());
                          window.history.replaceState({}, "", location.pathname + (_searchParams.toString() ? "?" + _searchParams.toString() : ""));
                        }
                        resolve();
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }())["catch"](function (error) {
                dispatchLoading(false);

                // Invalid search params surface as NotFound410Exception (mapped
                // from the search-lab 400 in searchLabClient). Soft-navigate to
                // a non-existent path so the catch-all route renders the 404
                // page — reloading the same bad URL would 400 again and loop.
                if ((error === null || error === void 0 ? void 0 : error.name) === "NotFound410Exception") {
                  navigateTo("/404");
                  resolve();
                  return;
                }
                reject(error);
              });
            }));
        }
      }, _callee2);
    }));
    return function dispatchSearchAction() {
      return _ref2.apply(this, arguments);
    };
  }();
  var isSearchSaved = useMemo(function () {
    var _searchResults$search, _searchResults$select;
    if (!(searchResults !== null && searchResults !== void 0 && (_searchResults$search = searchResults.search_meta) !== null && _searchResults$search !== void 0 && _searchResults$search.id) || !isFiltersOnlyPage || !isNaN(dealId) || (searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$select = searchResults.selectedOptions) === null || _searchResults$select === void 0 ? void 0 : _searchResults$select.length) === 0) {
      return true;
    }
    return Array.isArray(search_hashes) && (search_hashes === null || search_hashes === void 0 ? void 0 : search_hashes.some(function (hash) {
      var _searchResults$search2;
      return hash === (searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$search2 = searchResults.search_meta) === null || _searchResults$search2 === void 0 ? void 0 : _searchResults$search2.id);
    }));
  }, [filters, search_hashes, searchResults === null || searchResults === void 0 ? void 0 : searchResults.search_meta, isLoggedIn, searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$select2 = searchResults.selectedOptions) === null || _searchResults$select2 === void 0 ? void 0 : _searchResults$select2.length]);
  var handleSaveFilters = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _window, _window$location, _searchResults$search3;
      var path;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            path = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search;
            if (path.includes("page=")) {
              path = path.replace(/&?page=\d+/, "");
            }
            _context3.n = 1;
            return remote_saveSearch((_searchResults$search3 = searchResults.search_meta) === null || _searchResults$search3 === void 0 ? void 0 : _searchResults$search3.id, searchResults.search_meta.title, path, searchResults.selectedOptions || []);
          case 1:
            return _context3.a(2, _context3.v);
        }
      }, _callee3);
    }));
    return function handleSaveFilters() {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    preserveData(searchResults);
  }, [searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$metaDa2 = searchResults.metaData) === null || _searchResults$metaDa2 === void 0 ? void 0 : _searchResults$metaDa2.currentPage, searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$metaDa3 = searchResults.metaData) === null || _searchResults$metaDa3 === void 0 ? void 0 : _searchResults$metaDa3.productsCount]);
  useEffect(function () {
    var _searchResults$metaDa4, _searchResults$metaDa5;
    if (!isAutosOrYearsScreen(location) || searchResults.posts.length === 0) return;
    unbxdAnalytics({
      action: "categoryPage",
      pid: "",
      url: serverUrl + location.pathname + location.search,
      requestId: ((_searchResults$metaDa4 = searchResults.metaData) === null || _searchResults$metaDa4 === void 0 ? void 0 : _searchResults$metaDa4.request_id) || "N.A",
      page: ((_searchResults$metaDa5 = searchResults.metaData) === null || _searchResults$metaDa5 === void 0 ? void 0 : _searchResults$metaDa5.category_path) || "",
      page_type: "BOOLEAN"
    });
  }, [searchResults.posts]);
  useEffect(function () {
    // const isComingFromPostView = referralPage.includes(CARD_DETAIL);
    // !isComingFromPostView && pageNumber > 1 && dispatchSearchAction(pageNumber);
    dispatchSearchAction(pageNumber);
    setIsFirstLanding(false);
  }, [pageNumber]);
  useEffect(function () {
    if (lastScrollPosition) {
      setTimeout(function () {
        return window.scrollTo({
          top: lastScrollPosition
        });
      }, 3);
    }
    return function () {
      preserveScrollPosition();
    };
  }, []);
  useEffect(function () {
    var pageTitle = getSearchPageTitle(searchResults);
    if (pageTitle) {
      document.title = pageTitle;
    }
  }, [searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$metaDa6 = searchResults.metaData) === null || _searchResults$metaDa6 === void 0 ? void 0 : _searchResults$metaDa6.title]);
  useEffect(function () {
    var isLocationFirstPage = !window.location.search.includes("page=");
    var isAutosOrYearsAndFirstLanded = isFirstLanding && isAutosOrYearsScreen(location);
    var isComingFromPostView = referralPage.includes(CARD_DETAIL);
    var isComingFromCarCompare = referralPage.includes(CARD_COMPARE);
    var nofacets = !searchResults.filters || searchResults.filters.length === 0;
    if (nofacets || isLocationFirstPage && !isComingFromPostView && !isComingFromCarCompare && !isAutosOrYearsAndFirstLanded) {
      setPage(1);
      dispatchSearchAction(1);
      if (!isFirstLanding) {
        setSearchResults(_objectSpread(_objectSpread({}, searchResults), {}, {
          posts: []
        }));
        window.scrollTo(0, 0);
      }
    }
    setIsFirstLanding(false);
  }, [location.search, location.pathname]);
  var contextValue = {
    searchTerm: searchTerm,
    sort: sort,
    page: pageNumber,
    searchResults: searchResults,
    isLoading: isLoading,
    //dispatcher
    dispatchLoading: dispatchLoading,
    // Events
    runWhenElementViewed: runWhenElementViewed,
    //helpers
    hasMorePages: hasMorePages,
    //filters
    showFilters: showFilters,
    setShowFilters: setShowFilters,
    //Flags
    isAutosPage: isAutosPage,
    isCarCountriesPage: isCarCountriesPage,
    isYearsPage: isYearsPage,
    isDealPage: isDealPage,
    //constants
    dealId: dealId,
    isSearchSaved: isSearchSaved,
    search_meta: searchResults.search_meta,
    handleSaveFilters: handleSaveFilters,
    total_pages: (_searchResults$metaDa7 = searchResults.metaData) === null || _searchResults$metaDa7 === void 0 ? void 0 : _searchResults$metaDa7.totalPages,
    setPage: setPage
  };
  return /*#__PURE__*/React.createElement(searchPaginationContext.Provider, {
    value: contextValue
  }, children);
};